<mat-toolbar>
  <h3>Time per product owner</h3>
  <span class="spacer"></span>
  @if (pending()) {
    <button matIconButton disabled class="rotating">
      <mat-icon>refresh</mat-icon>
    </button>
  }
</mat-toolbar>

<div class="cell-actions">
  <mat-form-field>
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input [rangePicker]="poPicker">
      <input matStartDate required placeholder="Start date" [(ngModel)]="poStart" />
      <input matEndDate required placeholder="End date" [(ngModel)]="poEnd" />
    </mat-date-range-input>
    <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="poPicker"></mat-datepicker-toggle>
    <mat-date-range-picker #poPicker></mat-date-range-picker>
  </mat-form-field>
</div>

<div style="overflow-y: auto">
  <table mat-table [dataSource]="source()" [trackBy]="trackBy" style="min-width: max-content">
    <ng-container matColumnDef="name" sticky>
      <th mat-header-cell *matHeaderCellDef style="width: 20vw">Product Owner</th>
      <td mat-cell *matCellDef="let item">
        <div class="flex flex--row">
          {{ item.name }}
          <span class="spacer"></span>
          <mat-icon>{{ expandedPo()[item.name] ? 'unfold_less' : 'unfold_more' }}</mat-icon>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef>Active Projects</th>
      <td mat-cell *matCellDef="let item">{{ item.activeProjects }}</td>
    </ng-container>
    <ng-container matColumnDef="liability">
      <th mat-header-cell *matHeaderCellDef>
        Current Liability (inc. not invoiced)
        <mat-icon matTooltip="Current Liability hours are shown as of now (ignoring selected dates)"
          >help_outline</mat-icon
        >
      </th>
      <td mat-cell *matCellDef="let item">
        {{ item.time | number: '.0-2' }}
        @if (item.notInvoiced > 0) {
          <span matTooltip="Not invoiced yet"> ({{ item.notInvoiced.toFixed(2) }}) </span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="team_logged">
      <th mat-header-cell *matHeaderCellDef>
        Logged by the team
        <mat-icon matTooltip="Logged hours are shown for the selected date range">help_outline</mat-icon>
      </th>
      <td mat-cell *matCellDef="let item">{{ item.teamLogged | number: '.0-2' }}</td>
    </ng-container>
    <ng-container matColumnDef="po_logged">
      <th mat-header-cell *matHeaderCellDef>
        Logged by PO
        <mat-icon matTooltip="Logged hours are shown for the selected date range">help_outline</mat-icon>
      </th>
      <td mat-cell *matCellDef="let item">{{ item.poOwnLogged | number: '.0-2' }}</td>
    </ng-container>
    <ng-container matColumnDef="active_score">
      <th mat-header-cell *matHeaderCellDef class="bg-score">
        Active products/agreements
        <mat-icon matTooltip="at the current point in time">help_outline</mat-icon>
      </th>
      <td mat-cell *matCellDef="let item">{{ item.activeScore | number: '.0-2' }}</td>
    </ng-container>
    <ng-container matColumnDef="responsibility_score">
      <th mat-header-cell *matHeaderCellDef class="bg-score">
        Volume of responsibility (hrs)
        <mat-icon matTooltip="at the current point in time">help_outline</mat-icon>
      </th>
      <td mat-cell *matCellDef="let item">{{ item.responsibilityScore | number: '.0-2' }}</td>
    </ng-container>
    <ng-container matColumnDef="team_score">
      <th mat-header-cell *matHeaderCellDef class="bg-score">
        Logged for PO’s projects by all team members (hrs)
        <mat-icon matTooltip="for the current reporting week">help_outline</mat-icon>
      </th>
      <td mat-cell *matCellDef="let item">{{ item.teamScore | number: '.0-2' }}</td>
    </ng-container>
    <ng-container matColumnDef="po_score">
      <th mat-header-cell *matHeaderCellDef class="bg-score">
        Logged by PO (hrs)
        <mat-icon matTooltip="for the current reporting week">help_outline</mat-icon>
      </th>
      <td mat-cell *matCellDef="let item">{{ item.poScore | number: '.0-2' }}</td>
    </ng-container>
    <ng-container matColumnDef="sales_score">
      <th mat-header-cell *matHeaderCellDef class="bg-score">
        Sales/pre-sales done by PO
        <mat-icon matTooltip="for the current reporting week">help_outline</mat-icon>
      </th>
      <td mat-cell *matCellDef="let item">{{ item.salesScore | number: '.0-2' }}</td>
    </ng-container>
    <ng-container matColumnDef="total_score">
      <th mat-header-cell *matHeaderCellDef class="bg-score">Total</th>
      <td mat-cell *matCellDef="let item">{{ item.totalScore | number: '.0-2' }}</td>
    </ng-container>
    <ng-container matColumnDef="toggle">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item">
        <mat-icon>
          @if (expandedPo[item.name]) {
            arrow_drop_up
          } @else {
            arrow_drop_down
          }
        </mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="filler">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let proj"></td>
    </ng-container>
    <ng-container matColumnDef="proj_name" sticky>
      <th mat-header-cell *matHeaderCellDef>Project</th>
      <td mat-cell *matCellDef="let proj">
        <em> {{ proj[2].ClientCode }} {{ proj[2].JobNumber }} </em>
        {{ proj[2].Title }}
        @if ('Active' !== proj[2].Status) {
          <em> ({{ proj[2].Status }}) </em>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="proj_liability">
      <th mat-header-cell *matHeaderCellDef>Liability</th>
      <td mat-cell *matCellDef="let proj">
        @let time = timeTable()[proj[0]]?.time || 0;

        {{ time > 0 ? time : 0 }}
        @if (proj[2].NotInvoicedYet > 0) {
          <span matTooltip="Not invoiced yet"> ({{ proj[2].NotInvoicedYet }}) </span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="proj_team_logged">
      <th mat-header-cell *matHeaderCellDef>Logged by the team</th>
      <td mat-cell *matCellDef="let proj">{{ proj[1] || 0 | number: '.0-2' }}</td>
    </ng-container>
    <ng-container matColumnDef="proj_po_logged">
      <th mat-header-cell *matHeaderCellDef>Logged by PO</th>
      <td mat-cell *matCellDef="let proj">{{ (poOwnLogged()[proj[3]] || {})[proj[0]] || 0 | number: '.0-2' }}</td>
    </ng-container>
    <ng-container matColumnDef="separator">
      <th mat-header-cell *matHeaderCellDef class="bg-separator"></th>
      <td mat-cell *matCellDef="let proj" class="bg-separator"></td>
    </ng-container>
    <tr
      mat-header-row
      *matHeaderRowDef="
        [
          'name',
          'active',
          'liability',
          'team_logged',
          'po_logged',
          'separator',
          'active_score',
          'responsibility_score',
          'team_score',
          'po_score',
          'sales_score',
          'total_score',
          'toggle',
        ];
        sticky: true
      "
    ></tr>
    <tr
      mat-row
      *matRowDef="
        let item;
        columns: [
          'name',
          'active',
          'liability',
          'team_logged',
          'po_logged',
          'separator',
          'active_score',
          'responsibility_score',
          'team_score',
          'po_score',
          'sales_score',
          'total_score',
          'toggle',
        ]
      "
      (click)="expandPo(item.name)"
      style="cursor: pointer"
    ></tr>
    <tr
      mat-row
      [hidden]="!expandedPo()[proj[3]]"
      *matRowDef="
        let proj;
        when: isProjectRow;
        columns: [
          'proj_name',
          'filler',
          'proj_liability',
          'proj_team_logged',
          'proj_po_logged',
          'filler',
          'filler',
          'filler',
          'filler',
          'filler',
          'filler',
          'filler',
        ]
      "
    ></tr>
  </table>
</div>
